document.addEventListener('DOMContentLoaded', function () {
  var hamburger = document.querySelector('.hamburger');
  var mobileNav = document.getElementById('mobile-nav');

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      var isOpen = mobileNav.classList.toggle('is-open');
      hamburger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.classList.toggle('menu-open', isOpen);
    });

    // Close mobile nav when an anchor link is clicked
    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileNav.classList.remove('is-open');
        hamburger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('menu-open');
      });
    });
  }
});

// Anchor nav active state on scroll
(function(){
  var anchorLinks = document.querySelectorAll('.anchor-nav-link');
  if(!anchorLinks.length) return;
  var sections = ['new','package','detail','spec','story','news']
    .map(function(id){return document.getElementById(id);}).filter(Boolean);
  function setActive(){
    var scrollY = window.scrollY + 100;
    var current = '';
    sections.forEach(function(sec){
      if(sec && sec.offsetTop <= scrollY) current = sec.id;
    });
    anchorLinks.forEach(function(link){
      var href = link.getAttribute('href').replace('#','');
      link.classList.toggle('is-active', href === current);
    });
  }
  window.addEventListener('scroll', setActive, {passive:true});
  setActive();
})();

// Strip variant info from wishlist product names (keep only product title before " - ")
(function(){
  function stripVariant(el){
    var text = el.textContent;
    var idx = text.indexOf(' - ');
    if(idx !== -1) el.textContent = text.substring(0, idx);
  }
  function processAll(){
    document.querySelectorAll('.wishlist-hero-list-card-header-product-name').forEach(stripVariant);
  }
  var observer = new MutationObserver(processAll);
  observer.observe(document.body, { childList: true, subtree: true });
  processAll();
})();

// Fix: make header shopify-section sticky
(function(){
  var hdr = document.querySelector('header');
  if(hdr && hdr.parentElement){
    var p = hdr.parentElement;
    p.style.position = 'sticky';
    p.style.top = '0';
    p.style.zIndex = '100';
  }
})();

// Scroll reveal: fade + rise in whenever a section's content enters the viewport.
// Add class="reveal" to any element in a section to opt it in — no JS changes needed per-section.
(function () {
  var selectors = [
    '.reveal',
    '.section-head',
    '.hero-content',
    '.tile',
    '.commit-item',
    '.package-intro',
    '.package-photo',
    '.detail-points-heading',
    '.point-wrap',
    '.news-item',
    '.review-row',
    '.howto-item',
    '.story-label',
    '.story-title',
    '.story-text',
    '.spec-photo-col',
    '.spec-table',
    '.campaign-hero-content',
    '.campaign-offer-text',
    '.campaign-offer-card',
    '.campaign-colors-head',
    '.campaign-colors-card',
    '.campaign-product-card',
    '.campaign-line-card',
    '.campaign-line-eyebrow.is-section-head',
    '.campaign-faq-item'
  ];
  var els = document.querySelectorAll(selectors.join(','));
  if (!els.length) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion || !('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('reveal', 'is-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

  els.forEach(function (el) {
    var siblings = el.parentElement
      ? Array.prototype.filter.call(el.parentElement.children, function (c) { return c.matches(selectors.join(',')); })
      : [el];
    var idx = siblings.indexOf(el);
    el.classList.add('reveal');
    el.style.transitionDelay = Math.min(idx * 0.08, 0.32) + 's';
    observer.observe(el);
  });
})();